<template>
  <div id="app">
    <router-view v-if="already" />
  </div>
</template>

<script>
import { validateSession } from '@/services/auth-service';
import { verifyIfIsUnsupportedBrowser } from '@/shared/utils/helpers';
import { connectWebRTC, endWebRTCSession } from '@/weon/web-rtc/WeonWebRTC.js';

export default {
  name: 'App',
  data() {
    return {
      already: false,
    };
  },
  created() {
    if (verifyIfIsUnsupportedBrowser())
      return this.redirectUnsupportedBrowser();
    if (['TabDisabled', 'LostConnection'].includes(this.$route.name)) {
      this.already = true;
      return;
    }
    this.$store._vm.$root.$on('storageReady', () => {
      const agentId = this.$store.state.attendance.Attendance.agentId;
      const orgUnitId = this.$store.state.attendance.Attendance.org_unit_id;

      const requestData = {
        agent_id: agentId,
        org_unit_id: orgUnitId,
      };

      if (agentId != '') {
        validateSession(requestData)
          .then(() => {
            this.$store.dispatch(
              '_connection/setConnectionWebRTCStatus',
              'disconnected',
            );
            this.$store.dispatch('_connection/lostWebRTCConnection', false);
            if (
              this.$store.state.attendance.Attendance.useWebRTC == 'Y' &&
              this.$store.state.attendance.Attendance.agentPreferences
                .webRtcAutoReconnect &&
              !this.$store.state.attendance.Attendance.agentAbsent
                .agentAbsentEnabled
            ) {
              connectWebRTC(
                this.$store.state.attendance.Attendance.agentId,
                this.$store.state.attendance.Attendance.org_unit_id,
              );
            }

            this.$store.dispatch('attendance/getAgent', {
              identifier:
                this.$store.state.attendance.Attendance.loginIdentifier,
              channels: this.$store.state.attendance.Attendance.channels,
            });

            this.$store.dispatch('attendance/getStatusAgent', agentId);
            this.already = true;
          })
          .catch(() => {
            this.disconnect();
          });
      } else {
        this.disconnect();
      }
    });
    this.$store.dispatch('getWhiteLabelTheme');
  },
  methods: {
    redirectUnsupportedBrowser() {
      this.$router.push({ path: '/unsupported-browser' });
      this.already = true;
    },
    disconnect() {
      endWebRTCSession();
      this.$store.dispatch('resetState');
      indexedDB.deleteDatabase('localforage');
      this.$router.push({ path: '/login' });
      this.already = true;
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');

.application {
  font-family: 'Roboto', sans-serif !important;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
}

.headline,
.title,
.display-1,
.display-2,
.display-3,
.display-4,
.body-2,
.body-1,
.caption,
.subheading {
  font-family: 'Roboto', sans-serif !important;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
}
</style>

<style src="./material.css"></style>
